/**
 * As revisões do perito em vigor na avaliação da formalização (E152.F3, ADR-0103 §5.9): as que o
 * perito pode rever e as registradas que a avaliação usa. Saíram de `formalizacaoAvaliacao` na
 * E184.F3 (GUS-145 item 4), quando o aceite com fundamento entrou nos tipos da revisão.
 */
import type {
  AvaliacaoDaFormalizacaoData,
  PainelDaFormalizacaoData,
  RevisaoEmVigorData,
} from './formalizacaoAvaliacao';

/** As revisões em vigor que o perito pode rever: as que não estão pendentes de novo. */
export function revisaveis(a: AvaliacaoDaFormalizacaoData): RevisaoEmVigorData[] {
  const pendentes = new Set(a.revisoes_pendentes.map((r) => r.objeto));
  return a.revisoes_em_vigor.filter((r) => !pendentes.has(r.objeto));
}

export function emVigor(a: AvaliacaoDaFormalizacaoData, objeto: string): boolean {
  return a.revisoes_em_vigor.some((r) => r.objeto === objeto);
}

/** As revisões registradas que a avaliação usa: a mais recente por objeto (por tipo na face, no
 * suprimento e nas diligências, como o servidor monta) e com o objeto em vigor nesta versão. */
export function revisoesVigentes(painel: PainelDaFormalizacaoData): Set<string> {
  const vistas = new Set<string>();
  const vigentes = new Set<string>();
  for (const r of painel.revisoes) {
    const chave = r.tipo === 'contraprova' ? `contraprova:${r.objeto}` : r.tipo;
    if (vistas.has(chave)) continue;
    vistas.add(chave);
    if (emVigor(painel.avaliacao.conteudo.avaliacao, r.objeto)) vigentes.add(r.id);
  }
  return vigentes;
}
